import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { formatPrice } from '../../../DeviationViews/TierProductCardDumb/utils';
import { DeviationResourceType } from '../../../types/deviation';
var SubscribeVariant = function (_a) {
    var tier = _a.tier, _b = _a.tier.tier, _c = _b === void 0 ? {} : _b, dollarPrice = _c.dollarPrice, _d = _a.withPrice, withPrice = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, className = _a.className, href = _a.href, onSubscribe = _a.onSubscribe;
    var t = useTranslation().t;
    var restrictToLoggedIn = useRestrictToLoggedIn().restrictToLoggedIn;
    var subscribe = restrictToLoggedIn(ReferralType.MEMBER_SUBSCRIBE, onSubscribe);
    var showPrice = withPrice && dollarPrice;
    return (React.createElement(BrandedButton, { isFakeButton: true, className: className, size: size, variant: "brand-green", href: href, onClick: function (e) {
            if (!onSubscribe) {
                return;
            }
            subscribe(tier);
            e.stopPropagation();
            e.preventDefault();
        }, biData: {
            evid: BiEventType.TIER_SUBSCRIBE,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
        } }, showPrice
        ? t('deviation.tier.subscribeWithPrice', {
            dollarPrice: formatPrice(dollarPrice),
        })
        : t('deviation.tier.subscribe')));
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;
//# sourceMappingURL=Subscribe.js.map